// extracted by mini-css-extract-plugin
export default {"PointerBox":"user-notice-popover-module__PointerBox--xpI4M"};